import { areaTree, areaTreeCode } from "@/api/energy.js";
const state = {
  areatree: JSON.parse(sessionStorage.getItem("areatree")) || [],
  TreeCode:  JSON.parse(sessionStorage.getItem("areaTreeCode")) || [],
};
const getters = {
  getareatree(state) {
    return state.areatree;
  },
  getareatreeCode(state) {
    console.log(state.TreeCode, "库中获取");
    return state.TreeCode;
  }
};
const mutations = {
  REQ_AREATREE(state, payload) {
    state.areatree = payload;
    sessionStorage.setItem("areatree", JSON.stringify(payload))
  },
  REQ_TREECODE(state, payload) {
    state.TreeCode = payload;
    sessionStorage.setItem("areaTreeCode", JSON.stringify(payload))
  }
};
const actions = {
  areaTreeActions({ commit }) {
    areaTree(this.$token)
      .then(res => {
        if (res.data.code == 200) {
          // sessionStorage.setItem(
          //   "areaTree",
          //   res.data.data.areaTree[0].children
          // );
          commit("REQ_AREATREE", res.data.data.areaTree[0].children);
        }
      })
      .catch(err => {});
  },
  async areaTreeCodeActions({ commit }) {
    await areaTreeCode(this.$token)
      .then(res => {
        if (res.data.code == 200) {
          commit("REQ_TREECODE", res.data.data);
        }
      })
      .catch(err => {});
  }
};
export default {
  state,
  getters,
  mutations,
  actions,
  namespaced: true
};
